module.exports = __webpack_public_path__ + "static/media/countBeds.77f969b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/generalInformation/countBeds.svg
// module id = 303
// module chunks = 0